import React from 'react'
import './Title.less'

const Title = ({ children, type }) => <div className={`marley-title marley-title-${type}`}>{children}</div>

export default Title